import React, { FC, memo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormChildQuestionDto, FormQuestionDto } from "@green0meter/api-client";

import { FormControl, TextField } from "@components/base";
import { useDraftReturn } from "@hooks/useDraftField";

interface ShortText {
  parentQuestionCode?: string;
  question: FormQuestionDto | FormChildQuestionDto;
  disabled?: boolean;
  draftField?: useDraftReturn | null;
}

const ShortText: FC<ShortText> = ({
  parentQuestionCode,
  question,
  disabled,
  draftField,
}) => {
  const { control } = useFormContext();

  return (
    <FormControl fullWidth disabled={disabled}>
      <Controller
        name={
          parentQuestionCode
            ? `${parentQuestionCode}-${question.code}`
            : question.code
        }
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            variant="filled"
            placeholder={(question as FormQuestionDto).placeholder || question.name}
            value={field.value ?? ""}
            onFocus={draftField?.handleFocus}
            onBlur={draftField?.handleBlur}
            slotProps={{
              input: {
                disabled,
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default memo(ShortText);
